export default __webpack_public_path__ + "static/media/SpiLogo.385c6f03.svg";